import { render, staticRenderFns } from "./_termo.vue?vue&type=template&id=2fd57418&scoped=true"
import script from "./_termo.vue?vue&type=script&lang=ts"
export * from "./_termo.vue?vue&type=script&lang=ts"
import style0 from "./_termo.vue?vue&type=style&index=0&id=2fd57418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd57418",
  null
  
)

export default component.exports